// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ADar1","icon":"styles_icon__4_PVq"};